import { Col } from 'antd';
import React from 'react';
import { InactiveToggle, SearchFilter, SearchFilterContainer } from '../filters';
export const defaultAutomationSearchOptions = {
    hideInactive: false,
    searchText: ''
};
export const AutomationSearch = ({ onChange, queryParams }) => React.createElement(SearchFilterContainer, null,
    React.createElement(Col, { span: 12 },
        React.createElement(SearchFilter, { onChange: onChange })),
    React.createElement(Col, { className: 'align-right', span: 12 },
        React.createElement(InactiveToggle, { checked: Boolean(queryParams.hideInactive), onChange: onChange })));
